<template>
  <div style="background: white">
    <Header/>
    <div id="CompleteOrder">
      <a-result
          :style="{width: '800px', margin: '0 auto'}"
          :status="submitStatus"
          :title="submitStatus === 'success' ? '下单成功' : submitStatus === 'error' ? '下单失败' : '部分下单成功'"
      >
        <template #extra>
          <a-button key="index" @click="skipHome" type="primary">
            去首页
          </a-button>
<!--          <a-button key="cart" @click="skipCart">-->
<!--            去购物车-->
<!--          </a-button>-->
        </template>
        <div class="desc">
          <p v-for="(res, i) in responses" :key="i">
            <a-icon :style="{ color: res.code ? 'red' : 'green'}" :type="res.code ? 'close-circle' : 'check-circle'" />
            {{ res.supplierName }}{{ res.code ? '下单失败' : '下单成功' }}, {{ res.code ? `原因: ${res.msg}` : `订单号: ${res.data}` }}
          </p>
        </div>
      </a-result>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header";
const ORDER_RESPONSES = 'ORDER_RESPONSES'
import storage from 'store'
import {selectCartId} from "@/store/mutation-types";

export default {
  components: {
    Header
  },
  data () {
    return {
      responses: []
    }
  },
  computed: {
    submitStatus () {
      if (this.responses.every(res => !res.code)) {
        return 'success'
      } else if (this.responses.every(res => res.code)) {
        return 'error'
      }
      return 'warning'
    }
  },
  mounted () {
    this.responses = storage.get(ORDER_RESPONSES)
    storage.set(selectCartId, [])
    storage.set(ORDER_RESPONSES, [])
  },
  methods: {
    skipHome () {
      this.$router.push({
        path: '/'
      })
    },
    skipCart () {
      this.$router.push({
        path: '/cart'
      })
    }
  }
}
</script>
<style lang="less" scoped>
  #CompleteOrder{
    width: 1200px;
    margin: 0 auto;
    min-height: 95vh;
    .desc {
      font-size: 14px;
      text-align: center;
    }
  }
</style>
